<mat-button-toggle
  [checked]="showCloudProjection$ | async"
  (click)="toggleProjection()"
  class="toolbar-button"
  [disabled]="(areProjectionsEnabled$ | async) === false"
  [matTooltip]="
    (areProjectionsEnabled$ | async) === false
      ? 'Projections are loading...'
      : 'Toggle point cloud visibility'
  "
>
  <mat-icon [h3CustomIcon]="pointCloudProjectionIcon"></mat-icon>
</mat-button-toggle>
